import React, { useState } from 'react'
import "./AlertCribes.css"
import bell from "../../../assets/bell 1.svg"
import PopupAlert from '../../PopupAlert/PopupAlert'
import { useTranslation } from 'react-i18next'

const AlertCribes = () => {
  const {t}=useTranslation();
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const openPopup = () => {
    setIsPopupOpen(true);
  };

  const closePopup = () => {
    setIsPopupOpen(false);
  };
  return (
    <div className='alert text-center mt-3 row'>
      <div className="col-lg-7 d-flex flex-column align-items-center">
        <h2>{t("footer.question")}</h2>
        <button className='btn btn-alert' onClick={openPopup}>
          <img src={bell} alt='bell' />{t("footer.alert")}
        </button>
      </div>
      <PopupAlert isPopupOpen={isPopupOpen} onClose={closePopup} id="popupAlert2" />
    </div>
  )
}

export default AlertCribes
